import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule} from '@angular/material/paginator';
import { MatSelectModule} from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule} from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { WarehouseRoutingModule } from './warehouse-routing.module';
import { WarehouseComponent } from './warehouse.component';
import { DialogOverviewComponent } from './dialog-overview/dialog-overview.component';
import { WarehouseserviceService } from './warehouseservice.service';
import { DialogAskComponent } from './dialog-ask/dialog-ask.component';

@NgModule({
    imports: [CommonModule, WarehouseRoutingModule,
      MatTableModule,
      MatFormFieldModule,
      MatPaginatorModule,
      MatSelectModule,
      MatInputModule,
      MatCardModule,
      MatButtonModule,
      MatIconModule,
      MatDialogModule,
      FormsModule,
      ReactiveFormsModule
    ],
    declarations: [
      WarehouseComponent,
      DialogOverviewComponent,
      DialogAskComponent
    ],
    entryComponents: [
        DialogOverviewComponent,
        DialogAskComponent
    ],
    providers: [WarehouseserviceService]
})
export class WarehouseModule {}
